export { BookingInfo } from "./components/BookingInfo/BookingInfo";
export { BookingPolicy } from "./components/BookingPolicy/BookingPolicy";
